import { Component, HostBinding } from '@angular/core';
import { WizDatasource } from '@wizeoo/akm-component-lib';
import { BaseView, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { ModelExampleVO } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { MdChronocodeExampleTileRenderer } from '../renderer/home/md-chronocode-example-tile.renderer';
import { AgChronocodeExampleActionRenderer } from '../renderer/home/ag-chronocode-example-action.renderer';
import { Model } from 'src/app/model/model';

/**
 * Vue d'accueil des chronocodes
 * Author : SVA
 */
@Component({
  selector: 'chronocode-home-view',
  templateUrl: './chronocode-home.view.html',
})
export class ChronocodeHomeView extends BaseView {
  @HostBinding('style.padding') forcedNoPadding = 'padding: 0px !important'; // c'est une vue enfant
  
  
  /** Data source de la list des chronocodes' */
  public chronocodeExamplesDS: WizDatasource<ModelExampleVO> = new WizDatasource<ModelExampleVO>()
    .setSortFields([{ property: 'label', way: 'asc' }])
    .setSelectionMode('single')
    .build();

  /** Alimentation des données */
  public wizSynchronizeData(): void {
    super.wizSynchronizeData();
    this.chronocodeExamplesDS.setSource(ViewData.getInstance().fakeChronoCodeModel);
  }

  /**
   * configuration du multi liste des exemples de modèles
   */
  public examplesMultiConfig: MultiDisplayConfig<ModelExampleVO> = {
    model: Model.getInstance(),
    datasource: this.chronocodeExamplesDS,
    defaultMode: 'tiles',
    tiles: {
      enabled: true,
      renderer: MdChronocodeExampleTileRenderer,
      itemHeight: 150, itemWidth: 200
    },
    grid: {
      enabled: true,
      columns: [
        {
          headerName: '$.common.code.$',
          width: 100,
          sortable: true,
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: '$.common.label.$',
          flex: 1,
          sortable: true,
          field: 'description',
          cellRenderer: 'labelRenderer'
        },
        {
          headerName: '$.bu.home.application.actions.$',
          field: 'actions',
          width: 150,
          cellRenderer: 'exampleActionRenderer'
        }
      ],
      renderers: {
        labelRenderer: AgLabelValidityRenderer,
        exampleActionRenderer: AgChronocodeExampleActionRenderer,
      }
    }
  };
}
